<template>
    <lingallery
        v-if="galleryItems.length > 0"
        :items="galleryItems"
        :height="300"
        :iid.sync="currentId"
        :disableImageClick="true"
        :addons="{ enableLargeView: true }"
    >
    </lingallery>
    <img v-else :src="imageSrcProp" :alt="imageAltProp">
</template>

<script>
import Lingallery from 'lingallery';

export default {
    props: {
        imageSrcProp: {
            required: true,
            type: String
        },
        imageAltProp: {
            required: false,
            type: String
        },
        galleryImages: {
            required: false
        },
        lastKey: {
            required: false
        }
    },

    components: {
        Lingallery
    },

    data() {
      return {
          imageSrc: this.imageSrcProp,
          imageAlt: this.imageAltProp,
          galleryItems: this.galleryImages,
          currentId: null
      }
    },

    mounted() {
        this.galleryItems.unshift({
            id: this.lastKey + 1,
            src: this.imageSrcProp,
            thumbnail: this.imageSrcProp,
            caption: ''
        });

        this.$root.$on('setProduct', (data) => {

            if ( data.gallery !== null && data.gallery.length > 0 ) {
                this.galleryItems = [];

                data.gallery.forEach( (item, index) => {

                    this.galleryItems.push({
                        id: index + 1,
                        src: item.src,
                        thumbnail: item.src,
                        caption: ''
                    });

                    if ( index + 1 === data.gallery.length ) {
                        this.galleryItems.unshift({
                            id: index + 1,
                            src: data.previewImage,
                            thumbnail: data.previewImage,
                            caption: ''
                        });
                    }
                });
            } else {
                this.imageSrc = data.previewImage;
                this.imageAlt = data.productName;
            }
        });
    }
}
</script>
